module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUdwTDhy/zx0/zlu/zxz/zxy/zx0/z50/zp2/zxy/zx2/z50/zh0/z52/0XZk80AAAANdFJOUwC5kw6i+c9EUmTtMIHMjYSBAAAA30lEQVQ4y2NgGKzA7C4qSIZJ1KJJXIdJ8AiiggPkW849SQkZaG6AijO7oll+yQAiwXgXHQhAJOZiSNyESMhiSFyESKzFkLgFkbiLCSiTuDINSDjPxZQIMM69e8XAFFPiBjBaHBh0sdgxgVnEgAeb5XeAzLNYJJzBbBNMiQIwmx1TIqO8mmF7eRs2D15h8MXmwcyOboYdHdMwJRrAbA4SXHU1NITBNTSWBMtBEZqLIz5cYimNwVgM8asQiVwMiWsQCV0MiUsQCSsMicUQCXb0pHirAJoPjFJRxMOU6VUqAAAQV+2cIl9l9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_icon_18_zh.png
// module id = UUOw
// module chunks = 34